import SvgIcon from '@material-ui/core/SvgIcon';

function StopIcon(props) {
    return (
        <SvgIcon {...props}>
           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4 14H8V8h8z"></path>
        </SvgIcon>
    );
}

export default StopIcon;